import { ScreenshotField } from '@/components/feedback/ScreenshotField'
import { useFeedbackForm } from '@/components/feedback/useFeedbackForm'
import { Modal } from '@/components/ui'
import { FormField } from '@/components/ui/form'

const CATEGORIES = [
  { value: '', label: 'Select a category...' },
  { value: 'bug', label: 'Bug Report' },
  { value: 'suggestion', label: 'Suggestion' },
  { value: 'data_issue', label: 'Data Issue' },
  { value: 'other', label: 'Other' },
]

interface FeedbackModalProps {
  isOpen: boolean
  onClose: () => void
}

export function FeedbackModal({ isOpen, onClose }: FeedbackModalProps) {
  const {
    category,
    setCategory,
    title,
    setTitle,
    description,
    handleDescriptionChange,
    error,
    attachment,
    isPending,
    handleClose,
    handleSubmit,
  } = useFeedbackForm(onClose)

  return (
    <Modal isOpen={isOpen} onClose={handleClose}>
      <Modal.Form onSubmit={handleSubmit}>
        <Modal.Header onClose={handleClose}>Send Feedback</Modal.Header>
        <Modal.Body>
          <FormField label="Category" optional>
            <select value={category} onChange={(e) => setCategory(e.target.value)} className="input w-full">
              {CATEGORIES.map((c) => (
                <option key={c.value} value={c.value}>
                  {c.label}
                </option>
              ))}
            </select>
          </FormField>

          <FormField label="Title" optional>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="Brief summary..."
              className="input w-full"
              maxLength={200}
            />
          </FormField>

          <FormField label="Description" error={error}>
            <textarea
              value={description}
              onChange={(e) => handleDescriptionChange(e.target.value)}
              placeholder="What happened? What did you expect?"
              className="input w-full resize-none"
              rows={4}
              maxLength={5000}
            />
          </FormField>

          <ScreenshotField
            screenshot={attachment.screenshot}
            screenshotName={attachment.screenshotName}
            fileInputRef={attachment.fileInputRef}
            onSelect={attachment.handleScreenshot}
            onRemove={attachment.removeScreenshot}
          />
        </Modal.Body>

        <Modal.FormActions
          submitLabel="Submit"
          isSubmitting={isPending}
          isSubmitDisabled={!description.trim()}
          onCancel={handleClose}
        />
      </Modal.Form>
    </Modal>
  )
}
